import { render, staticRenderFns } from "./CreateKRA.vue?vue&type=template&id=53f429ee&scoped=true"
import script from "./CreateKRA.vue?vue&type=script&lang=js"
export * from "./CreateKRA.vue?vue&type=script&lang=js"
import style0 from "./CreateKRA.vue?vue&type=style&index=0&id=53f429ee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f429ee",
  null
  
)

export default component.exports